<script>
	import CompanyForm from './../Company/CompanyForm.svelte';
    import { TextInput } from "carbon-components-svelte";
    import Edit from "carbon-icons-svelte/lib/Edit.svelte";
    import Add from "carbon-icons-svelte/lib/Add.svelte";
    import User from "carbon-icons-svelte/lib/User.svelte";
    import { UserFilled } from "carbon-icons-svelte";
    import { createEventDispatcher } from 'svelte'

    export let company =  {
                "ABN": "",
                "ACN": "",
                "address": "",
                "id": "",
                "name": "",
                "people": [],
                "phone": ""
            }

    let formattedAddress = ""

    const dispatch = createEventDispatcher()

    inLineAddress()

    function inLineAddress() {
        // Check if addressObject is an object
        if (typeof company.address !== 'object' || company.address === null) {
            return "";
        }
        const { street, suburb, state, postcode } = company.address;
        // Filter out invalid fields (non-strings and non-numbers)
        const validFields = [street, suburb, state, postcode].filter(field => typeof field === 'string' || typeof field === 'number');
        // Construct the formatted address using valid fields
        formattedAddress = validFields.join(', ');
        return formattedAddress;
    }

    function editCompany() {
        dispatch('edit-company', company)
    }

    function companyUpdated() {

    }
</script>
    
<div class="company-summary-card">
    <div class="company-card-header">
        <span class="company-card-title">Parent Operating Entity</span>
        <button class="edit-btn" on:click={editCompany} title="Edit Company Details" type="button">
            <Edit size={16} />
            <span>Edit</span>
        </button>
    </div>

    <div class="company-meta-grid">
        <div class="meta-item">
            <span class="meta-label">Company Name</span>
            <span class="meta-val bold">{company.name || '—'}</span>
        </div>
        <div class="meta-item">
            <span class="meta-label">ABN</span>
            <span class="meta-val">{company.ABN || '—'}</span>
        </div>
        <div class="meta-item">
            <span class="meta-label">ACN</span>
            <span class="meta-val">{company.ACN || '—'}</span>
        </div>
        <div class="meta-item full">
            <span class="meta-label">Address</span>
            <span class="meta-val">{formattedAddress || '—'}</span>
        </div>
    </div>

    {#if company.contacts && company.contacts.length > 0}
        <div class="company-contacts-block">
            <span class="sub-heading">Entity Contacts</span>
            <table class="contacts-subtable">
                <thead>
                    <tr>
                        <th width="24px"></th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Position</th>
                    </tr>
                </thead>
                <tbody>
                    {#each company.contacts as person}
                        <tr>
                            <td class="user-cell">
                                {#if person.main}
                                    <span class="main-tag" title="Primary"><UserFilled size={16} /></span>
                                {:else}
                                    <User size={16} />
                                {/if}
                            </td>
                            <td class="bold">{person.name}</td>
                            <td>{person.phone}</td>
                            <td>{person.email}</td>
                            <td>{person.position}</td>        
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
    {/if}
</div>

<style>
    .company-summary-card {
        background-color: #ffffff;
        border: 1px solid var(--tt-slate-200);
        border-radius: 16px;
        padding: 16px;
        margin-top: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    }

    .company-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--tt-slate-200);
        padding-bottom: 8px;
    }

    .company-card-title {
        font-size: 11.5px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--tt-slate-700);
    }

    .edit-btn {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        background: transparent;
        border: 1px solid var(--tt-slate-300);
        border-radius: 9999px;
        padding: 4px 12px;
        font-size: 11px;
        font-weight: 600;
        color: var(--tt-slate-700);
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .edit-btn:hover {
        background-color: rgba(66, 133, 244, 0.08);
        color: var(--tt-primary);
        border-color: var(--tt-primary);
    }

    .company-meta-grid {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        gap: 8px 12px;
    }

    .meta-item {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .meta-item.full {
        grid-column: 1 / -1;
    }

    .meta-label {
        font-size: 11px;
        font-weight: 600;
        color: var(--tt-slate-500);
    }

    .meta-val {
        font-size: 13px;
        color: var(--tt-slate-800);
    }

    .meta-val.bold {
        font-weight: 600;
    }

    .company-contacts-block {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-top: 4px;
    }

    .sub-heading {
        font-size: 11px;
        font-weight: 600;
        color: var(--tt-slate-500);
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }

    .contacts-subtable {
        width: 100%;
        border-collapse: collapse;
        background: #ffffff;
        border: 1px solid var(--tt-slate-200);
        border-radius: var(--tt-radius-sm);
        overflow: hidden;
    }

    .contacts-subtable th {
        font-size: 11px;
        font-weight: 600;
        color: var(--tt-slate-600);
        background-color: var(--tt-slate-100);
        padding: 4px 8px;
        text-align: left;
    }

    .contacts-subtable td {
        font-size: 12px;
        color: var(--tt-slate-700);
        padding: 4px 8px;
        border-bottom: 1px solid var(--tt-slate-100);
    }

    .contacts-subtable tr:last-child td {
        border-bottom: none;
    }

    .user-cell {
        color: var(--tt-slate-400);
        text-align: center;
    }

    .main-tag {
        color: var(--tt-primary);
    }
</style>